var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGitflow = function SvgGitflow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gitflow_svg__a)",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15h13",
    stroke: "#24ADC5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(90 6 15)",
    cx: 6,
    cy: 15,
    r: 4,
    fill: "#B6E8ED",
    stroke: "#B6E8ED"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(90 44 15)",
    cx: 44,
    cy: 15,
    r: 4,
    fill: "#24ADC5",
    stroke: "#24ADC5"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(90 44 35)",
    cx: 44,
    cy: 35,
    r: 4,
    fill: "#24ADC5",
    stroke: "#24ADC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15h4.952a6 6 0 0 1 5.258 3.108l7.58 13.783A6 6 0 0 0 34.048 35H39.5",
    stroke: "url(#gitflow_svg__b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gitflow_svg__b",
    x1: 36.5,
    x2: 13,
    y1: 23.5,
    y2: 23.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24ADC5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6E8ED",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gitflow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h50v50H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGitflow);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9Im5vbmUiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDUwIDUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGNsaXAtcGF0aD0idXJsKCNnaXRmbG93YikiIHN0cm9rZS13aWR0aD0iNCI+PHBhdGggZD0ibTI2LjUgMTVoMTMiIHN0cm9rZT0iIzI0QURDNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PGNpcmNsZSB0cmFuc2Zvcm09InJvdGF0ZSg5MCA2IDE1KSIgY3g9IjYiIGN5PSIxNSIgcj0iNCIgZmlsbD0iI0I2RThFRCIgc3Ryb2tlPSIjQjZFOEVEIi8+PGNpcmNsZSB0cmFuc2Zvcm09InJvdGF0ZSg5MCA0NCAxNSkiIGN4PSI0NCIgY3k9IjE1IiByPSI0IiBmaWxsPSIjMjRBREM1IiBzdHJva2U9IiMyNEFEQzUiLz48Y2lyY2xlIHRyYW5zZm9ybT0icm90YXRlKDkwIDQ0IDM1KSIgY3g9IjQ0IiBjeT0iMzUiIHI9IjQiIGZpbGw9IiMyNEFEQzUiIHN0cm9rZT0iIzI0QURDNSIvPjxwYXRoIGQ9Im0xMSAxNWg0Ljk1MjRjMi4xODgxIDAgNC4yMDI4IDEuMTkxMiA1LjI1NzMgMy4xMDg1bDcuNTgwNiAxMy43ODNjMS4wNTQ1IDEuOTE3MyAzLjA2OTIgMy4xMDg1IDUuMjU3MyAzLjEwODVoNS40NTI0IiBzdHJva2U9InVybCgjZ2l0Zmxvd2EpIi8+PC9nPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iZ2l0Zmxvd2EiIHgxPSIzNi41IiB4Mj0iMTMiIHkxPSIyMy41IiB5Mj0iMjMuNSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIHN0b3AtY29sb3I9IiMyNEFEQzUiIG9mZnNldD0iMCIvPjxzdG9wIHN0b3AtY29sb3I9IiNCNkU4RUQiIG9mZnNldD0iMSIvPjwvbGluZWFyR3JhZGllbnQ+PGNsaXBQYXRoIGlkPSJnaXRmbG93YiI+PHJlY3Qgd2lkdGg9IjUwIiBoZWlnaHQ9IjUwIiBmaWxsPSIjZmZmIi8+PC9jbGlwUGF0aD48L2RlZnM+PC9zdmc+Cg==";